import moment from 'moment'
import { LED_BY_VALUE } from '../../../components/LeadByIndicator/constants'
import { requestDateFormat } from '../../../utils/moment'
import {
  CCReassignmentRequest,
  CCReassignRequestDataFormat,
  TCCRelatedItemReassign
} from '../types'

export const formatReassignDataToRequest = (
  values: TCCRelatedItemReassign,
  isReassign = true
): CCReassignRequestDataFormat => {
  const data: CCReassignRequestDataFormat = {}
  if (values.effective_date)
    data.effective_date = moment(values.effective_date).format(
      requestDateFormat
    )
  if (isReassign) {
    if (values.assignee) data.assignee = values.assignee
    if (!values.assignee) {
      data.assignee_set = {
        rfp_assignee_set: [],
        org_cc_assignee_set: []
      }
      Object.keys(LED_BY_VALUE).forEach((key) => {
        if (values[`${LED_BY_VALUE[key]}_responsible_rfp`]) {
          data.assignee_set?.rfp_assignee_set.push({
            led_by: LED_BY_VALUE[key],
            assignee: values[`${LED_BY_VALUE[key]}_responsible_rfp`]
          })
        }
        if (values[`${LED_BY_VALUE[key]}_responsible_contract`]) {
          data.assignee_set?.org_cc_assignee_set.push({
            led_by: LED_BY_VALUE[key],
            assignee: values[`${LED_BY_VALUE[key]}_responsible_contract`]
          })
        }
      })
    }
  }
  return data
}

export const formatReassignDataToForm = (values: CCReassignmentRequest) => {
  const data: TCCRelatedItemReassign = {}
  if (values.effective_date) data.effective_date = moment(values.effective_date)
  if (values.assignee) data.assignee = values.assignee
  if (values.assignee_set) {
    Object.keys(LED_BY_VALUE).forEach((key) => {
      if (
        values.assignee_set?.org_cc_assignee_set.find(
          (led_by) => led_by.led_by === LED_BY_VALUE[key]
        )
      ) {
        data[`${LED_BY_VALUE[key]}_responsible_contract`] =
          values.assignee_set?.org_cc_assignee_set.find(
            (led_by) => led_by.led_by === LED_BY_VALUE[key]
          )?.assignee
      }
      if (
        values.assignee_set?.rfp_assignee_set.find(
          (led_by) => led_by.led_by === LED_BY_VALUE[key]
        )
      ) {
        data[`${LED_BY_VALUE[key]}_responsible_rfp`] =
          values.assignee_set?.rfp_assignee_set.find(
            (led_by) => led_by.led_by === LED_BY_VALUE[key]
          )?.assignee
      }
    })
  }
  return data
}
